if (!customElements.get('cart-recommendations')) {
	class CartRecommendations extends HTMLElement {
		async connectedCallback() {
			if (!this.sectionId || !this.productId || !this.limit) {
				return;
			}
			this.modalWrapper = document.querySelector('.cart-recommendations-modal-wrapper');
			if (!CartRecommendations.cache[this.productId]) {
				CartRecommendations.cache[this.productId] = fetch(
					`${theme.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}`,
				);
			}
			const response = await CartRecommendations.cache[this.productId];
			const div = document.createElement('div');
			div.innerHTML = await response.clone().text();
			const productRecommendationsElement = div.querySelector('cart-recommendations');

			if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
				this.innerHTML = productRecommendationsElement.innerHTML;
				this.initEventsListener();
			} else {
				this.hidden = true;
			}
		}
		initEventsListener() {
			this.initQuickShopEventsListener();
			this.initATCEventsListener();
		}
		initQuickShopEventsListener() {
			if (!this.modalWrapper) {
				this.modalWrapper = document.querySelector('.cart-recommendations-modal-wrapper');
			}
			this.modalWrapper.innerHTML = '';
			const products = this.querySelectorAll('.grid-product-quick-shop-item');
			if (!products.length) {
				return;
			}
			const mouseOverHandler = (evt) => {
				const el = evt.currentTarget;
				el.removeEventListener('mouseover', mouseOverHandler);
				if (!el || !el.dataset.productId) {
					return;
				}
				const productId = el.dataset.productId;
				const handle = el.dataset.productHandle;
				const btn = el.querySelector('.quick-product__btn');
				theme.preloadProductModal(handle, productId, btn);
			};
			products.forEach((product) => {
				if (theme.config.bpSmall) {
					const openModalAfterLoad = true;
					const productId = product.dataset.productId;
					const handle = product.dataset.productHandle;
					const btn = product.querySelector('.quick-product__btn');
					btn?.addEventListener('click', (event) => {
						theme.preloadProductModal(handle, productId, btn, openModalAfterLoad);
					});
				} else {
					product.addEventListener('mouseover', mouseOverHandler);
				}
			});

			this.querySelectorAll('.modal--quick-shop').forEach((el) => {
				this.modalWrapper.appendChild(el);
			});
		}
		initATCEventsListener() {
			this.querySelectorAll('[ajax-atc]').forEach((btn) => {
				btn.addEventListener('click', (event) => {
					event.preventDefault();
					const variantId = btn.dataset.variantId;
					document.dispatchEvent(
						new CustomEvent('atc:variant', {
							detail: {
								btn: btn,
								variantId: variantId,
							},
						}),
					);
				});
			});
		}
		async reInit() {
			if (!this.sectionId || !this.productId || !this.limit) {
				return;
			}
			if (!CartRecommendations.cache[this.productId]) {
				CartRecommendations.cache[this.productId] = fetch(
					`${theme.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}`,
				);
			}
			const response = await CartRecommendations.cache[this.productId];
			const div = document.createElement('div');
			div.innerHTML = await response.clone().text();
			const productRecommendationsElement = div.querySelector('cart-recommendations');
			if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
				this.innerHTML = productRecommendationsElement.innerHTML;
				this.initEventsListener();
			} else {
				this.hidden = true;
			}
		}
		set productId(value) {
			this.setAttribute('product-id', value);
			this.reInit();
		}
		get productId() {
			return this.getAttribute('product-id');
		}
		get limit() {
			return this.getAttribute('limit');
		}
		get sectionId() {
			return this.getAttribute('section-id');
		}
	}
	CartRecommendations.cache = {};
	window.customElements.define('cart-recommendations', CartRecommendations);
}
